import React, { useState, useEffect, useContext} from 'react'
import { Form, Button, Container, Col, Row, Card, ProgressBar, Alert, InputGroup, Modal } from 'react-bootstrap'
import { CartCheck } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

import CSAM_LOGO from '../../../images/csam-logo.jpeg'

// @type {PaymentsClient}
// @private
import AuthContext from '../../../context/AuthProvider';
const REGISTER_URL = '/user/register'




export default function SignupMembership() {
    const {auth, setAuth} = useContext(AuthContext)
    const navigate = useNavigate()
    const [isMounted, didMount] = useState(false)
    const [loading, isLoading] = useState(true)
    const [mode, setMode] = useState('')

    const [membershipFormComplete, setMembershipFormComplete] = useState(false)
    

    const [errMsg, setErrMsg] = useState('')
    const [isERROR, setError] = useState(false)

    //cards
    const [itemSelected, selectedItem ] = useState(0)
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    const [membershipFocus, setMembershipFocus] = useState()
    const handleShow = (e, index) => {
        e.preventDefault()
        setShow(true)
    }


    //user information
    const [occupation, setOccupation] = useState('')
    const [otherQualifications, setOtherQualifications] = useState('')
    const [address, setAddress] = useState({
        country: '',
        city: '',
        province: '',
        street1: '',
        street2:'',
        postalCode: ''
      });
    const [addressFilled, setAddressFilled] = useState(false)
    

    

    const membership_levels = [
        {
            id: 1,
            name: "Students - $15/year",
            description: "Includes all learners such as undergraduates, medical students, medical residents, etc.",
            membershipType: "student",
            duration: "1",
            cost: "$15",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        },
        {
            id: 2,
            name: "Professionals - $50/year",
            membershipType: "professional",
            description: "Includes physcians, nurses, and other medical professionals.",
            duration: "1",
            cost: "$50",
            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
        }
]

    useEffect(()=> {
        // if user already a member route to user account page
        if (auth.ismember == 'true') { // is or was a member

            if ( auth.membership_is_expired == 'true') {
                setMode('Membership Renewal in Grace Period')
                didMount(true)
            } else {
                navigate('/myaccount')
            }
        } else {
            setMode('New member')
            didMount(true)
        }
        
    },[])

    useEffect(()=> {

        if (isMounted) {
            isLoading(false)
        }
    },[isMounted])

    useEffect(()=> {

        if (itemSelected != 0 && !loading) {

            
            for ( var item of membership_levels) {
                // console.log(item.id, itemSelected, loading)
                const el = document.getElementById(item.id)

                if (item.id == itemSelected) {
                    el.classList.add("active-card")
                } else {
                    el?.classList.remove("active-card")
                }
            }
        
        
        }
    }, [itemSelected, loading])

    // check if all the fields are field, before reviewing info
    useEffect(()=> {
        //console.log(address)
        //check if address correctly filled
        if (address.country != '' && address.city != '' && address.province != '' && address.street1 != '' && address.postalCode != '') {
            setAddressFilled(true)
        } else {
            setAddressFilled(false)
        }

        // console.log(occupation, itemSelected)
        if (occupation == "Student"){
                selectedItem(1)
        } else if (occupation != '') {
                selectedItem(2)
            }
        


    }, [address.country, address.city, address, occupation, itemSelected])

    useEffect(()=> {
        
        //ready to review results
        if (addressFilled && occupation != '') {
            setMembershipFormComplete(true)
            setErrMsg('')
        } else {
            
            setErrMsg("Please fill the required fields.")
            setMembershipFormComplete(false)
        }

    }, [addressFilled, occupation])


    useEffect(()=> {
        // console.log(errMsg)
        if (errMsg == '') {
            setError(false)
        } else {
            setError(true)
        }
    },[errMsg])

    const handleCheckout = async (e) => {
        e.preventDefault()
        setErrMsg('')
        setError(false)

        try {
            const response = await axios.post("/user/create-checkout-session", {
                user: auth,
                address,
                items: [
                    {
                        id: itemSelected, 
                        quantity: 1
                    }
                ]
            })

            console.log(response.data)
            
            if (response.data.url) {
                window.location = response.data.url
            }
            
        } catch (error) {
            console.error(error)
            setErrMsg('An error occurred during checkout. Please ensure all fields are filled correctly and try again.')
            setError(true)
        }
    }

    // const onSubmit= async (e) => {

    //    e.preventDefault()
    //    navigate("/login")
    // }

    
    if (!loading){
    return (
        <Container className='mt-100 mb-5'>
            <Form>
                <Row className="mt-2">
                    <Col></Col>
                    <Col xs={12} md={10} lg={8}>
                        <Card className='mt-2' style={{ 
                            border: 'none', 
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)', 
                            borderRadius: '12px' 
                        }}>
                            <Card.Header style={{ 
                                fontWeight: "600", 
                                fontSize: "1.25rem",
                                backgroundColor: '#f8f9fa',
                                borderBottom: '2px solid #e9ecef',
                                borderRadius: '12px 12px 0 0',
                                padding: '1.25rem'
                            }}> 
                                Update User Information 
                            </Card.Header>
                            <Card.Body style={{ padding: '2rem' }}>
                                {
                                    errMsg != '' ? (
                                        <Alert 
                                            variant='danger' 
                                            className="mt-2" 
                                            style={{ 
                                                borderRadius: '8px',
                                                border: '1px solid #f5c6cb'
                                            }}
                                        >
                                            { errMsg }
                                        </Alert>
                                    ):(<></>)
                                }

                                <Form.Group className='form-group mb-4'>
                                    {/* <Form.Label style={{ 
                                        fontWeight: '600', 
                                        fontSize: '1rem',
                                        marginBottom: '0.75rem',
                                        color: '#495057'
                                    }}>
                                        Billing Address
                                    </Form.Label> */}

                                    <Row className="mt-1 g-3">
                                        <Col xs={12}>
                                            <Form.Control 
                                                type="text" 
                                                value={address.street1} 
                                                onChange={e=> {setAddress({...address, street1: e.target.value})}} 
                                                placeholder='Address Line 1*'
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 g-3">
                                        <Col xs={12}>
                                            <Form.Control 
                                                type="text" 
                                                value={address.street2} 
                                                onChange={e=> {setAddress({...address, street2: e.target.value})}} 
                                                placeholder='Address Line 2 (Optional)'
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                            />
                                            <Form.Text className="text-muted" style={{ fontSize: '0.85rem' }}>
                                                Apartment, suite, floor, building, or PO Box
                                            </Form.Text>
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 g-3">
                                        <Col xs={12} md={6}>
                                            <Form.Control 
                                                type="text" 
                                                value={address.city} 
                                                onChange={e=> {setAddress({...address, city: e.target.value})}} 
                                                placeholder='City'
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Control 
                                                type="text" 
                                                value={address.province} 
                                                onChange={e=> {setAddress({...address, province: e.target.value})}}  
                                                placeholder='Province/State*'
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3 g-3">
                                        <Col xs={12} md={6}>
                                            <Form.Control 
                                                type="text" 
                                                value={address.country} 
                                                onChange={e=> {setAddress({...address, country:e.target.value})}} 
                                                placeholder='Country*'
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                                required
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <Form.Control 
                                                type="text" 
                                                value={address.postalCode} 
                                                onChange={e=> {setAddress({...address, postalCode: e.target.value})}} 
                                                placeholder='Postal/Zip Code*'
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                </Form.Group>
                                
                                <Row className="mt-4 g-3"> 
                                    <Col xs={12} md={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Label style={{ 
                                                fontWeight: '600', 
                                                fontSize: '0.95rem',
                                                marginBottom: '0.5rem',
                                                color: '#495057'
                                            }}> 
                                                Current Background/Occupation 
                                            </Form.Label>
                                            <Form.Select
                                                value={occupation}
                                                onChange={ e => { {setOccupation(e.target.value)}}}
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                                required
                                            >
                                                <option value=""> Select from below </option>
                                                <option value="Student"> Student </option>
                                                <option value="MD"> Medical Professional </option>
                                                <option value="Nurse"> Nurse </option>
                                                <option value="Engineer"> Engineer </option>
                                                <option value="Other"> Other </option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Label style={{ 
                                                fontWeight: '600', 
                                                fontSize: '0.95rem',
                                                marginBottom: '0.5rem',
                                                color: '#495057'
                                            }}> 
                                                Qualifications/Interests <span style={{ fontWeight: '400', fontSize: '0.85rem', color: '#6c757d' }}>(Optional)</span>
                                            </Form.Label>
                                            <Form.Control 
                                                type="text"
                                                value={otherQualifications}
                                                onChange={e=> {setOtherQualifications(e.target.value)}}
                                                placeholder='e.g., BSc, MSc, Research interests'
                                                style={{
                                                    borderRadius: '8px',
                                                    padding: '0.65rem',
                                                    border: '1px solid #ced4da'
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                            </Card.Body>

                            <Card.Footer style={{ 
                                textAlign: "center", 
                                backgroundColor: '#f8f9fa',
                                borderTop: '2px solid #e9ecef',
                                borderRadius: '0 0 12px 12px',
                                padding: '1.5rem'
                            }}>
                                <Button 
                                    variant="warning" 
                                    className="" 
                                    style={{ 
                                        borderRadius: "8px",
                                        padding: '0.75rem 2rem',
                                        fontWeight: '600',
                                        fontSize: '1rem',
                                        border: 'none',
                                        boxShadow: membershipFormComplete ? '0 4px 12px rgba(255,193,7,0.3)' : 'none',
                                        transition: 'all 0.3s ease'
                                    }} 
                                    disabled={!membershipFormComplete}
                                    onClick={e=> { handleCheckout(e) }}>
                                    Complete Checkout & Pay <CartCheck style={{ marginLeft: '0.5rem' }} /> 
                                </Button>
                                {!membershipFormComplete && (
                                    <div style={{ 
                                        marginTop: '0.75rem', 
                                        fontSize: '0.875rem', 
                                        color: '#6c757d' 
                                    }}>
                                        Please fill in all required fields
                                    </div>
                                )}
                            </Card.Footer>

                        </Card>
                    </Col>
                    <Col></Col> 
                 </Row>

                 <Row>
                    <Col></Col>
                    <Col xs={12} md={10} lg={8}>
                        <Card className='mt-4' style={{ 
                            border: 'none', 
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)', 
                            borderRadius: '12px' 
                        }}>
                            <Card.Header style={{ 
                                fontWeight: "600", 
                                fontSize: "1.1rem",
                                backgroundColor: '#f8f9fa',
                                borderBottom: '2px solid #e9ecef',
                                borderRadius: '12px 12px 0 0',
                                padding: '1rem 1.25rem'
                            }}>
                                Membership Tiers
                            </Card.Header>
                            <Card.Body style={{ padding: '1.5rem' }}>
                                <Alert variant="info" style={{ 
                                    borderRadius: '8px',
                                    fontSize: '0.9rem',
                                    marginBottom: '1.5rem'
                                }}>
                                    Your membership tier is automatically determined based on your selected background/occupation.
                                </Alert>

                                <Row className="g-4">
                            {membership_levels.map((item, index)=> {
                                        
                                        return(
                                            <Col xs={12} sm={6} key={item.id}>
                                                <Card 
                                                    id={item.id} 
                                                    className="membership-item h-100"
                                                    style={{
                                                        border: '2px solid #e9ecef',
                                                        borderRadius: '12px',
                                                        transition: 'all 0.3s ease',
                                                        cursor: 'default'
                                                    }}
                                                >
                                                    <Card.Img 
                                                        variant="top" 
                                                        src={CSAM_LOGO} 
                                                        style={{ 
                                                            padding: '1rem',
                                                            objectFit: 'contain',
                                                            maxHeight: '150px'
                                                        }}
                                                    />
                                                    <Card.Body style={{ padding: '1.25rem' }}>
                                                        <Card.Title style={{ 
                                                            fontSize: "1.1rem",
                                                            fontWeight: '600',
                                                            marginBottom: '1rem',
                                                            color: '#495057'
                                                        }}>
                                                            {item.name} 
                                                        </Card.Title>
                                                        <Card.Text style={{ 
                                                            fontSize: '1rem',
                                                            fontWeight: '600',
                                                            color: '#495057'
                                                        }}>
                                                            <span style={{ color: '#ffc107' }}>{item.cost}</span> annually
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card>
   
                                            </Col>
                                        )
                                    })}

                 </Row>
                    <Modal show={show} onHide={handleClose} animation={false}>
                                            <Modal.Header closeButton>
                                                <Modal.Title> {membershipFocus?.name}</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <h6> Membership Details </h6>
                                                <p>
                                                    {membershipFocus?.description}
                                                </p>
                                                
                                                <p>
                                                    <strong> Price: </strong> {membershipFocus?.cost} annually
                                                </p>
                                                
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={handleClose}>
                                                        Close
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col> </Col>
                </Row> 
            </Form>

        </Container>

    )}


}